// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_n7-1";
export var rowFirst = "_n7-3";
export var rowLast = "_n7-5";
export var rowMiddle = "_n7-4";
export var ticketListScroll = "_n7-2";
export var ticketStack = "_n7-0";